import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Use environment variables, with fallback to production values for backwards compatibility
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://scmtfyjpaivqbafbtooy.supabase.co";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "sb_publishable_KUGC9Zsi24IyuI3qVziuWg_3sUYMpQZ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY);